/* src/app/layout/menu/menu.component.scss */
.di-nav {
  margin-top: -5px;
}
.di-nav ul {
  display: flex;
}
.di-nav ul li {
  margin: 0 24px 0 0;
  position: relative;
}
.di-nav ul li:last-child {
  margin-right: 0;
}
.di-nav ul li .nav-item {
  color: #333333;
  text-decoration: none;
  font-size: 1rem;
  cursor: pointer;
}
.di-nav ul li .nav-item svg {
  margin-left: 4px;
}
.di-nav ul li .nav-item svg path {
  fill: #888;
}
.di-nav ul li .nav-item:before {
  content: "";
  position: absolute;
  width: 0;
  height: 3px;
  background: #004c93;
  bottom: -6px;
  left: 0;
  transition: all 0.3s;
}
.di-nav ul li .nav-item.active,
.di-nav ul li .nav-item:hover,
.di-nav ul li .nav-item.active-child-menu {
  color: #004c93;
}
.di-nav ul li .nav-item.active:before,
.di-nav ul li .nav-item:hover:before,
.di-nav ul li .nav-item.active-child-menu:before {
  width: 30px;
}
.di-nav ul li .sub-menu {
  position: absolute;
  top: calc(100% + 3px);
  border-radius: 4px;
  background: #ffffff;
  box-shadow:
    0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  z-index: 100;
  min-width: 160px;
  visibility: hidden;
  opacity: 0;
  -ms-transform: translateY(17px);
  transform: translateY(17px);
  will-change: transform, opacity;
  transition:
    transform 0.3s linear,
    opacity 0.3s linear,
    visibility 0.3s linear;
}
.di-nav ul li .sub-menu ul {
  display: flex;
  flex-direction: column;
}
.di-nav ul li .sub-menu ul li {
  margin: 0;
}
.di-nav ul li .sub-menu ul li a {
  color: #333333;
  text-decoration: none;
  font-size: 1rem;
  display: flex;
  padding: 9px 15px;
}
.di-nav ul li .sub-menu ul li a:hover {
  color: #004c93;
  background: rgba(0, 0, 0, 0.04);
}
.di-nav ul li .sub-menu ul li a .mobile-txt {
  display: none;
}
.di-nav ul li .sub-menu ul li:last-child {
  margin-bottom: 0;
}
.di-nav ul li:hover .sub-menu {
  visibility: visible;
  opacity: 1;
  -ms-transform: translateY(0);
  transform: translateY(0);
}
@media screen and (max-width: 768px) {
  .di-nav ul li {
    margin-right: 12px;
  }
}
/*# sourceMappingURL=menu.component-YTXOBSHV.css.map */
